module.exports = __webpack_public_path__ + "static/media/microphone-fill.456c45c7.svg";